import { useState, useCallback, useRef } from 'react';

// Only the most obvious typos that should be auto-corrected
const COMMON_TYPOS = {
  // Very common typos
  'teh': 'the',
  'tehm': 'them',
  'adn': 'and',
  'hte': 'the',
  'thier': 'their',
  'theres': 'theirs',
  'youre': 'you\'re',
  'its': 'it\'s',
  'wont': 'won\'t',
  'dont': 'don\'t',
  'cant': 'can\'t',
  'isnt': 'isn\'t',
  'wasnt': 'wasn\'t',
  'werent': 'weren\'t',
  'hasnt': 'hasn\'t',
  'havent': 'haven\'t',
  'didnt': 'didn\'t',
  'doesnt': 'doesn\'t',
  'shouldnt': 'shouldn\'t',
  'couldnt': 'couldn\'t',
  'wouldnt': 'wouldn\'t',
  
  // Receive/believe pattern
  'recieve': 'receive',
  'recieved': 'received',
  'recieving': 'receiving',
  'beleive': 'believe',
  'beleived': 'believed',
  'beleiving': 'believing',
  'acheive': 'achieve',
  'acheived': 'achieved',
  'acheiving': 'achieving',
  'concieve': 'conceive',
  'concieved': 'conceived',
  'concieving': 'conceiving',
  'deceive': 'deceive',
  'decieved': 'deceived',
  'decieving': 'deceiving',
  'percieve': 'perceive',
  'percieved': 'perceived',
  'percieving': 'perceiving',
  
  // Separate pattern
  'seperate': 'separate',
  'seperated': 'separated',
  'seperating': 'separating',
  'seperation': 'separation',
  'desparate': 'desperate',
  'desparately': 'desperately',
  
  // Definitely pattern
  'definately': 'definitely',
  'definatly': 'definitely',
  'defintely': 'definitely',
  'definitly': 'definitely',
  'defiantly': 'definitely',
  
  // Occurred pattern
  'occured': 'occurred',
  'occuring': 'occurring',
  'occurence': 'occurrence',
  'occassion': 'occasion',
  'occassional': 'occasional',
  'occassionally': 'occasionally',
  
  // Beginning/weird pattern
  'begining': 'beginning',
  'wierd': 'weird',
  'freind': 'friend',
  'freinds': 'friends',
  'freindly': 'friendly',
  'freindship': 'friendship',
  
  // Common words
  'calender': 'calendar',
  'neccessary': 'necessary',
  'neccesary': 'necessary',
  'tommorow': 'tomorrow',
  'tommorrow': 'tomorrow',
  'accomodate': 'accommodate',
  'acommodate': 'accommodate',
  'embarass': 'embarrass',
  'embarassing': 'embarrassing',
  'embarassed': 'embarrassed',
  'goverment': 'government',
  'enviroment': 'environment',
  'enviromental': 'environmental',
  'restaraunt': 'restaurant',
  'resturant': 'restaurant',
  'maintainance': 'maintenance',
  'independant': 'independent',
  'independance': 'independence',
  'comittee': 'committee',
  'comitted': 'committed',
  'comitting': 'committing',
  'proffesional': 'professional',
  'proffesionally': 'professionally',
  'aquire': 'acquire',
  'aquired': 'acquired',
  'aquiring': 'acquiring',
  
  // More common typos
  'anwser': 'answer',
  'anwsered': 'answered',
  'anwsering': 'answering',
  'arguement': 'argument',
  'arguements': 'arguments',
  'availible': 'available',
  'availiblity': 'availability',
  'buisness': 'business',
  'buissness': 'business',
  'changeing': 'changing',
  'charachter': 'character',
  'charachters': 'characters',
  'completly': 'completely',
  'compleatly': 'completely',
  'concious': 'conscious',
  'conciousness': 'consciousness',
  'curiousity': 'curiosity',
  'decison': 'decision',
  'decisons': 'decisions',
  'developement': 'development',
  'develoment': 'development',
  'dicipline': 'discipline',
  'dissapoint': 'disappoint',
  'dissapointed': 'disappointed',
  'dissapearing': 'disappearing',
  'experiance': 'experience',
  'experianced': 'experienced',
  'experincing': 'experiencing',
  'expirience': 'experience',
  'explaination': 'explanation',
  'familar': 'familiar',
  'finaly': 'finally',
  'foriegn': 'foreign',
  'fourty': 'forty',
  'greatful': 'grateful',
  'grammer': 'grammar',
  'guarentee': 'guarantee',
  'guarenteed': 'guaranteed',
  'happend': 'happened',
  'happends': 'happens',
  'immediatly': 'immediately',
  'imediatly': 'immediately',
  'importent': 'important',
  'intresting': 'interesting',
  'intrest': 'interest',
  'intrested': 'interested',
  'judgement': 'judgment',
  'knowlege': 'knowledge',
  'knowladge': 'knowledge',
  'lenght': 'length',
  'liason': 'liaison',
  'libary': 'library',
  'liberry': 'library',
  'managment': 'management',
  'mispell': 'misspell',
  'mispelled': 'misspelled',
  'mispelling': 'misspelling',
  'neice': 'niece',
  'nieghbor': 'neighbor',
  'nieghbors': 'neighbors',
  'occassionally': 'occasionally',
  'orignal': 'original',
  'orginally': 'originally',
  'orginize': 'organize',
  'orginized': 'organized',
  'orginizing': 'organizing',
  'paralell': 'parallel',
  'paralells': 'parallels',
  'particulary': 'particularly',
  'payed': 'paid',
  'peice': 'piece',
  'peices': 'pieces',
  'persue': 'pursue',
  'persued': 'pursued',
  'persuing': 'pursuing',
  'posession': 'possession',
  'posessions': 'possessions',
  'prefered': 'preferred',
  'prefering': 'preferring',
  'probly': 'probably',
  'probobly': 'probably',
  'publically': 'publicly',
  'reccomend': 'recommend',
  'reccommend': 'recommend',
  'reccomended': 'recommended',
  'refering': 'referring',
  'religous': 'religious',
  'rember': 'remember',
  'remeber': 'remember',
  'rememberd': 'remembered',
  'responsability': 'responsibility',
  'responsable': 'responsible',
  'rythm': 'rhythm',
  'scedule': 'schedule',
  'sceduled': 'scheduled',
  'seperated': 'separated',
  'similiar': 'similar',
  'sincerly': 'sincerely',
  'speach': 'speech',
  'strenght': 'strength',
  'succesful': 'successful',
  'succesfully': 'successfully',
  'suceed': 'succeed',
  'suceeded': 'succeeded',
  'suceeding': 'succeeding',
  'sucess': 'success',
  'suprise': 'surprise',
  'suprised': 'surprised',
  'suprising': 'surprising',
  'temperture': 'temperature',
  'therfore': 'therefore',
  'thorugh': 'through',
  'thourgh': 'through',
  'truely': 'truly',
  'untill': 'until',
  'usefull': 'useful',
  'usualy': 'usually',
  'usally': 'usually',
  'wheter': 'whether',
  'wether': 'whether',
  'wich': 'which',
  'witht': 'with',
  'writting': 'writing',
  'writen': 'written',
  'youself': 'yourself',
  
  // Double letter confusions
  'allready': 'already',
  'alright': 'all right',
  'alot': 'a lot',
  'aswell': 'as well',
  'incase': 'in case',
  'infact': 'in fact',
  'inspite': 'in spite',
  'instead': 'instead',
  'nevermind': 'never mind',
  'noone': 'no one',
  'someone': 'someone',
  'somone': 'someone',
  'eveything': 'everything',
  'everyting': 'everything',
  'everthing': 'everything',
  'someting': 'something',
  'somthing': 'something',
  'anything': 'anything',
  'anyhting': 'anything',
  'anytihng': 'anything'
};

// Words that should never be auto-corrected (slang, abbreviations, etc.)
const PROTECTED_WORDS = new Set([
  'ur', 'u', 'r', 'n', 'w', 'y', 'bc', 'cuz', 'lol', 'omg', 'btw', 'imo', 'fyi', 'tbh',
  'idk', 'ikr', 'smh', 'brb', 'gtg', 'thx', 'ty', 'np', 'hey', 'yo', 'yeah', 'yep', 
  'nah', 'ok', 'okay', 'cool', 'def', 'prolly', 'tho', 'gonna', 'wanna', 'gotta'
]);

export const useSpellCheck = (options = {}) => {
  const {
    enabled = true,
    autoCorrectEnabled = true, // Light auto-correction enabled
    browserSpellCheckEnabled = true,
  } = options;

  const [corrections, setCorrections] = useState([]);
  const correctionTimeoutRef = useRef(null);

  // Get cursor position in textarea
  const getCursorPosition = useCallback((element) => {
    if (!element) return 0;
    return element.selectionStart || 0;
  }, []);

  // Set cursor position in textarea
  const setCursorPosition = useCallback((element, position) => {
    if (!element) return;
    element.selectionStart = position;
    element.selectionEnd = position;
  }, []);

  // Find word boundaries around cursor position
  const getWordAtPosition = useCallback((text, position) => {
    const beforeCursor = text.substring(0, position);
    const afterCursor = text.substring(position);
    
    // Find word boundaries (non-letter characters)
    const wordBoundaryRegex = /[^a-zA-Z]/;
    
    let wordStart = beforeCursor.length;
    for (let i = beforeCursor.length - 1; i >= 0; i--) {
      if (wordBoundaryRegex.test(beforeCursor[i])) {
        wordStart = i + 1;
        break;
      }
      if (i === 0) wordStart = 0;
    }
    
    let wordEnd = position;
    for (let i = 0; i < afterCursor.length; i++) {
      if (wordBoundaryRegex.test(afterCursor[i])) {
        wordEnd = position + i;
        break;
      }
      if (i === afterCursor.length - 1) wordEnd = position + afterCursor.length;
    }
    
    return {
      word: text.substring(wordStart, wordEnd),
      start: wordStart,
      end: wordEnd
    };
  }, []);

  // Light auto-correction with input handler
  const handleInputChange = useCallback((event, originalOnChange, textareaRef) => {
    if (!enabled || !autoCorrectEnabled) {
      originalOnChange(event);
      return;
    }

    const element = event.target;
    const newValue = element.value;
    const cursorPos = getCursorPosition(element);
    
    // Check if user typed a space or punctuation (trigger auto-correction)
    const lastChar = newValue[cursorPos - 1];
    const shouldAutoCorrect = lastChar && /[\s,.!?;:\n]/.test(lastChar);
    
    if (shouldAutoCorrect) {
      // Clear any pending correction timeout
      if (correctionTimeoutRef.current) {
        clearTimeout(correctionTimeoutRef.current);
      }
      
      // Auto-correct the word before the trigger character
      const beforeTrigger = newValue.substring(0, cursorPos - 1);
      const wordInfo = getWordAtPosition(beforeTrigger, beforeTrigger.length);
      const word = wordInfo.word.toLowerCase();
      
      // Only correct if it's in our typos list and not protected
      if (COMMON_TYPOS[word] && !PROTECTED_WORDS.has(word)) {
        const correction = COMMON_TYPOS[word];
        
        // Preserve original capitalization
        let finalCorrection = correction;
        if (wordInfo.word[0] === wordInfo.word[0].toUpperCase()) {
          finalCorrection = correction.charAt(0).toUpperCase() + correction.slice(1);
        }
        
        if (finalCorrection !== wordInfo.word) {
          console.log(`Auto-correcting: "${wordInfo.word}" → "${finalCorrection}"`);
          
          const correctedText = newValue.substring(0, wordInfo.start) + 
                              finalCorrection + 
                              newValue.substring(wordInfo.end);
          
          const newCursorPos = wordInfo.start + finalCorrection.length + 1; // +1 for trigger char
          
          // Update the textarea value
          element.value = correctedText;
          
          // Set cursor position after correction
          requestAnimationFrame(() => {
            setCursorPosition(element, newCursorPos);
          });
          
          // Call original onChange with corrected value
          const correctedEvent = { ...event, target: { ...element, value: correctedText } };
          originalOnChange(correctedEvent);
          
          // Track correction for undo
          setCorrections(prev => [...prev, {
            original: wordInfo.word,
            correction: finalCorrection,
            position: wordInfo.start,
            timestamp: Date.now()
          }]);
          
          return;
        }
      }
    }
    
    // No correction needed, proceed with normal change
    originalOnChange(event);
  }, [enabled, autoCorrectEnabled, getCursorPosition, setCursorPosition, getWordAtPosition]);

  // Undo last correction
  const undoLastCorrection = useCallback((currentText, element) => {
    if (corrections.length === 0) return currentText;
    
    const lastCorrection = corrections[corrections.length - 1];
    const { original, correction, position } = lastCorrection;
    
    // Find the correction in the current text and replace it back
    const beforeCorrection = currentText.substring(0, position);
    const afterCorrection = currentText.substring(position + correction.length);
    const restoredText = beforeCorrection + original + afterCorrection;
    
    // Remove the correction from history
    setCorrections(prev => prev.slice(0, -1));
    
    // Set cursor after the restored word
    if (element) {
      requestAnimationFrame(() => {
        setCursorPosition(element, position + original.length);
      });
    }
    
    return restoredText;
  }, [corrections, setCursorPosition]);

  // Get spell check attributes for textarea
  const getSpellCheckProps = useCallback(() => {
    return {
      spellCheck: enabled && browserSpellCheckEnabled, // Browser spell check for everything else
      autoCorrect: 'off', // Disable mobile auto-correct to avoid conflicts
      autoCapitalize: 'sentences',
      autoComplete: 'off'
    };
  }, [enabled, browserSpellCheckEnabled]);

  // Other functions for compatibility
  const clearCorrections = useCallback(() => {
    setCorrections([]);
  }, []);

  const getSuggestions = useCallback((word) => {
    return []; // Let browser handle suggestions
  }, []);

  const getBestCorrection = useCallback((word) => {
    const lowerWord = word.toLowerCase();
    return COMMON_TYPOS[lowerWord] || null;
  }, []);

  const isWordCorrect = useCallback((word) => {
    const lowerWord = word.toLowerCase();
    return !COMMON_TYPOS[lowerWord]; // Only flag words in our typos list as incorrect
  }, []);

  const addToDictionary = useCallback((word) => {
    console.log(`Word "${word}" - use browser's right-click menu to add to dictionary`);
    return true;
  }, []);

  return {
    enabled,
    autoCorrectEnabled,
    isReady: true,
    handleInputChange,
    getSpellCheckProps,
    corrections,
    undoLastCorrection,
    clearCorrections,
    getSuggestions,
    getBestCorrection,
    isWordCorrect,
    addToDictionary,
    lastCorrectionPosition: -1
  };
};

export default useSpellCheck; 